import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';

export const MODAL_TEXT = {
  HEADER: 'Create a new photo post',
  HEADER_EDIT: 'Edit your post',
  SUB_HEADER_1: 'You can create a new photo post here',
  SUB_HEADER_2:
    'New Dish and New Promo posts are created in the My Menu and Promote Yourself pages when creating a new item',
  OPTIONAL_TEXT: '[Optional]',
  SEND_TEXT: 'Send',
  UPDATE_TEXT: 'Update',
  DELETE_TEXT: 'Delete',
  CLOSE_TEXT: 'Close',
  UPLOAD_SECTION: {
    HEADER: 'Upload a photo or video',
    DROP_ZONE: `Drag photo or video here ${Delimiter} ${Delimiter} from your device`,
    DROP_ZONE_REPLACE_1: `or`,
    DROP_ZONE_REPLACE_2: `Select`,
  },
  CAPTION_SECTION: {
    HEADER: 'Write a caption',
    PLACEHOLDER: 'Describe your post here...',
  },
  FOOD_ITEM_SECTION: {
    HEADER: 'Link a food item',
    PLACEHOLDER: 'Select a food item',
  },
  CONFIRM_DELETE: {
    HEADER: 'Delete Post',
    MESSAGE: 'Are you sure you want to delete this post?',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
  },
};
